const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export interface UploadedDocumentResult {
  id: string;
  name: string;
  duplicateOfDocumentId?: string;
}

export interface UploadDocumentsResult {
  uploaded: UploadedDocumentResult[];
  failures: number;
}

export interface UploadDocumentsTarget {
  customerId: string;
  projectId: string;
  token: string;
}

/**
 * Uploads files to a project one at a time via `POST /documents`, matching
 * `useProjectFileDrop.performUpload`'s request shape exactly. Shared by the
 * project drop/rename flow and the Quick Start agent's `upload` step so
 * there's a single implementation of "how a file becomes a document".
 */
export async function uploadDocuments(
  files: File[],
  target: UploadDocumentsTarget,
  onProgress?: (done: number, total: number) => void
): Promise<UploadDocumentsResult> {
  const uploaded: UploadedDocumentResult[] = [];
  let failures = 0;

  for (const file of files) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('customerId', target.customerId);
    fd.append('projectId', target.projectId);
    try {
      const res = await fetch(`${API_BASE_URL}/documents`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${target.token}` },
        body: fd,
      });
      if (!res.ok) {
        failures++;
      } else {
        const data = await res.json().catch(() => null);
        if (data?.id) {
          uploaded.push({ id: data.id, name: data.name || file.name, duplicateOfDocumentId: data.duplicateOfDocumentId });
        } else {
          failures++;
        }
      }
    } catch {
      failures++;
    }
    onProgress?.(uploaded.length + failures, files.length);
  }

  return { uploaded, failures };
}
